import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import DoneIcon from '@mui/icons-material/Done'
import useWindowDimensions from '../../_common/WindowDimesnions'
import constants from '../../../config/constants'
import CustomCheckboxField from '../../_common/_form_fields/CustomCheckboxField'

const ServiceItem = (props) => {
  const { title, is_mandatory, service, selectedOptionalServices, setSelectedOptionalServices } = props
  const { width } = useWindowDimensions()

  const [serviceChecked, setServiceChecked] = useState(false)

  const titleStyle = {
    fontSize: '16px',
    marginBottom: '5px',
  }

  const checkboxStyle = {
    color: 'white',

    '&.Mui-checked': {
      color: 'white',
    },

    '& .MuiSvgIcon-root': {
      fontSize: width >= constants.xlBreakpoint ? 28 : 24,
    },
  }

  const handleChangeServiceChecked = (value) => {
    setServiceChecked(value)

    if (value) {
      setSelectedOptionalServices(prev => [...prev, service])
    } else {
      setSelectedOptionalServices(prev => prev.filter(item => item !== service))
    }
  }

  useEffect(() => {
    setServiceChecked(selectedOptionalServices.includes(service))
  }, [selectedOptionalServices, service])

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='flex-start'
      spacing={ is_mandatory ? 2 : 0 }
      sx={titleStyle}
    >
      <Box>
        {
          is_mandatory ?
          <DoneIcon /> :
          <CustomCheckboxField
            checked={serviceChecked}
            handleChange={handleChangeServiceChecked}
            sx={checkboxStyle}
          />
        }
      </Box>
      <Box
        sx={{
          cursor: is_mandatory ? 'default' : 'pointer',
        }}
        onClick={ is_mandatory ? () => {} : () => handleChangeServiceChecked(!serviceChecked) }
      >
        {title.value}
      </Box>
    </Stack>
  )
}

export default ServiceItem